<template>
  <scroll-center-dialog v-model="open" :loading="loading" :width="'500'" :applyable="false" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-row no-gutters justify="center">
      <v-btn
          class="btn"
          :loading="loading"
          :readonly="loading"
          @click="clickInfoDialog"
      >
        <span class="btn_text">
          ИНФОРМАЦИЯ УЧАСТНИКА
        </span>
      </v-btn>
      <v-btn
          class="btn"
          :loading="loading"
          :readonly="loading"
          @click="clickEmailDialog"
      >
        <span class="btn_text">
          ЭЛЕКТРОННАЯ ПОЧТА
        </span>
      </v-btn>
      <v-btn
          class="btn"
          :loading="loading"
          :readonly="loading"
          @click="clickMailingDialog"
      >
        <span class="btn_text">
          РАССЫЛКА
        </span>
      </v-btn>
      <v-btn
          class="btn"
          width="108"
          :loading="loading"
          :readonly="loading"
          @click="clickPasswordDialog"
      >
        <span class="btn_text">
          ПАРОЛЬ
        </span>
      </v-btn>
    </v-row>

    <user-email-dialog
      v-model="email_dialog"
      v-if="email_dialog"
      @save="acceptEmailDialog"
      @close="email_dialog = false"
    />
    <user-password-dialog
      v-model="password_dialog"
      v-if="password_dialog"
      @save="acceptPasswordDialog"
      @close="password_dialog = false"
    />
    <user-info-dialog
      :member="member"
      v-model="info_dialog"
      v-if="info_dialog"
      @save="acceptInfoDialog"
      @close="info_dialog = false"
    />
    <user-mailing-dialog
      :member="member"
      v-model="mailing_dialog"
      v-if="mailing_dialog"
      @save="acceptMailingDialog"
      @close="mailing_dialog = false"
    />
  </scroll-center-dialog>
</template>

<script>
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"
import UserEmailDialog from "@/modules/personal_account/users/modals/UserEmailDialog.vue"
import UserPasswordDialog from "@/modules/personal_account/users/modals/UserPasswordDialog.vue"
import UserInfoDialog from "@/modules/personal_account/users/modals/UserInfoDialog.vue"
import UserMailingDialog from "@/modules/personal_account/users/modals/UserMailingDialog.vue"

export default {
  name: "UserChangeDataDialog",
  props: {
    value: Boolean,
    member: Object
  },
  components: {
    UserMailingDialog,
    UserInfoDialog,
    UserPasswordDialog,
    UserEmailDialog,
    ScrollCenterDialog,
  },
  data () {
    return {
      open: false,
      loading: false,
      email_dialog: false,
      password_dialog: false,
      info_dialog: false,
      mailing_dialog: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  computed: {
    form_title () {
      return this.$vuetify.display.width < 320 ? 'личные данные' : 'изменить личные данные'
    },
  },
  methods: {
    acceptInfoDialog () {
      this.info_dialog = false
      this.$emit('save')
    },
    clickInfoDialog () {
      this.info_dialog = true
    },
    acceptMailingDialog () {
      this.mailing_dialog = false
      this.$emit('save')
    },
    clickMailingDialog () {
      this.mailing_dialog = true
    },
    acceptEmailDialog () {
      this.email_dialog = false
      this.$emit('save')
    },
    clickEmailDialog () {
      this.email_dialog = true
    },
    acceptPasswordDialog () {
      this.password_dialog = false
      this.$emit('save')
    },
    clickPasswordDialog () {
      this.password_dialog = true
    },
  },
  created () {}
}
</script>

<style scoped lang="scss">
.btn {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 60px 25px;
  padding: 0 20px;
  height: 40px;
  flex-shrink: 0;
  border: 2px solid #3254B9;
  border-radius: 5px;
  background: #3254B9;

  &:hover {
    background-color: transparent;

    .btn_text {
      color: #3254B9;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.btn_text {
  color: white;
  text-align: center;
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  letter-spacing: 0.7px;
  text-transform: uppercase;
}

@media screen and (max-width: 768px) {
  .btn_text {
    font-size: 13px;
    line-height: 15px;
  }
}
</style>
